import { useNavigate } from "react-router-dom";
import CustomButton from "./customButton";

const RecapTransporteur = () => {
  const navigate = useNavigate();
  return (
    <div className="border-grey border-[1px] rounded-[5px] ">
      <div className="bg-softGrey rounded-[5px] py-3 px-5">
        <ul className=" w-full flex justify-between ">
          <li>
            {" "}
            Demande envoyee le <br />
            20 Aout 2024{" "}
          </li>
          <li>
            <span className="text-grey text-sm font-normal">Produit: </span>{" "}
            <span>2</span>
          </li>
          <li>
            {" "}
            <span className="text-grey text-sm font-normal">
              Prix de transport estime:
            </span>{" "}
            <br />
            <span> 10000F</span>{" "}
          </li>
          <li>
            <span className="text-grey text-sm font-normal">Livraison a:</span>{" "}
            <br />
            <span className="text-primary text-sm font-normal">
              Order #90897
            </span>
          </li>
          <li>
            <span>No Commande </span> <br />{" "}
            <span className="text-primary text-sm font-normal">
              Order #90897
            </span>
          </li>
        </ul>
      </div>

      <div className="py-3 px-5 flex justify-between ">
        <div className="flex flex-col gap-4">
          <h3 className="text-[12px] font-normal">Prix de transports (6)</h3>
          <div className="flex w-full gap-3">
            {Array(4)
              .fill(0)
              .map((item, index) => {
                return (
                  <div
                    className="max-w-[134px] min-w-[134px] max-h-[171px] min-h-[171px] py-1 px-2 flex flex-col items-center gap-1 "
                    style={{ boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)" }}
                  >
                    <div className="w-full flex justify-end ">
                      <span className="text-grey text-[6px] font-normal">
                        il ya 5min
                      </span>
                    </div>
                    <div className="max-w-[61px] min-w-[61px] max-h-[61px] min-h-[61px] rounded-full bg-grey">
                      <img
                        className="w-full h-full object-cover"
                        src="/avatar1.svg"
                        alt=""
                      />
                    </div>
                    <div className=" flex flex-col items-center">
                      <span className="text-[10px]">Herves fifen..</span>
                      <span className="text-[8px]">Bertoua-cameroun</span>
                      <span className="text-primary text-[10px]">12000F</span>
                      <span
                        className="underline text-[10px]"
                        onClick={() => navigate("/detail_trans")}
                        style={{cursor:'pointer'}}
                      >
                        Voir ses details
                      </span>
                    </div>
                    <div className="flex  gap-2 items-center">
                      <CustomButton className="bg-primary text-white px-2 py-1 text-[7px]">
                        <span>Payer</span>
                      </CustomButton>
                      <CustomButton className="bg-third text-black px-2 py-1 text-[7px]">
                        <span>proposition</span>
                      </CustomButton>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default RecapTransporteur;
